import React from 'react'
import { Provider } from 'react-redux'
import { IntlProvider } from 'react-intl'
import { PersistGate } from 'redux-persist/integration/react'
import store from './redux/createStore'
import { persistor } from './redux/createStore'

import './App.css'

import Root from './containers/Root'

function App() {
    return (
        <Provider store={store}>
            <PersistGate persistor={persistor}>
                <IntlProvider locale="en">
                    <Root />
                </IntlProvider>
            </PersistGate>
        </Provider>
    )
}

export default App
